import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.XRay;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "XRay.Phaser.IntroductionScene.1",
            "XRay.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/XraySlider/scenes/GameIntro.ts